import * as React from "react"
import {Grid, Skeleton} from "@mui/material";


export default function PriceEvolutionTableLoadingBlock() {
	return <Grid container spacing={2}>
		<Grid item xs={6}>
			<Skeleton variant="rectangular" height={400}/>
		</Grid>

		<Grid item xs={6}>
			<Skeleton variant="rectangular" height={400}/>
		</Grid>
	</Grid>
}